module.exports = __webpack_public_path__ + "static/media/Delete.59f9a767.svg";